import { useState } from "react";
import { useStore, CAT_META } from "../store/Store";

// ─── OUTLINE CARD ─────────────────────────────────────────────────────────────
// Minimal, transparent — just a thin colored outline, no fill, no shadow at
// rest. Photo has generous whitespace around it. The quietest, most
// gallery-like style in the set — deliberate contrast to the bolder ones.
export default function OutlineCard({ p, onNav, accent }) {
  const { dispatch, wish, toggleWish, notify } = useStore();
  const [hovered, setHovered] = useState(false);
  const meta = CAT_META[p.category] || { emoji:"👗" };
  const disc = Math.round((1 - p.price / p.mrp) * 100);
  const wished = wish.includes(p.id);

  const addCart = (e) => {
    e.stopPropagation();
    dispatch({ type:"ADD", p:{ ...p, sc:p.colors?.[0]||"Default", ss:p.sizes?.[0]||"Free" } });
    notify(`${p.name} added!`);
    if (navigator.vibrate) navigator.vibrate(50);
  };

  return (
    <div
      onClick={()=>onNav("product", p.id)}
      onMouseEnter={()=>setHovered(true)}
      onMouseLeave={()=>setHovered(false)}
      style={{
        border:`1.5px solid ${hovered?accent:"#e5e5e5"}`, borderRadius:4, cursor:"pointer",
        background:"white", padding:16, transition:"all 0.3s ease",
        boxShadow: hovered ? `0 12px 28px ${accent}22` : "none",
      }}>
      <div style={{ height:230, position:"relative", display:"flex", alignItems:"center", justifyContent:"center" }}>
        {p.img
          ? <img src={p.img} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"contain" }} loading="lazy"/>
          : <div style={{ fontSize:44, opacity:0.2 }}>{meta.emoji}</div>
        }
        <button onClick={e=>{ e.stopPropagation(); toggleWish(p.id); if(navigator.vibrate)navigator.vibrate(30); }}
          style={{ position:"absolute", top:0, right:0, background:"none", border:"none", fontSize:15, cursor:"pointer" }}>
          {wished ? "❤️" : "🤍"}
        </button>
      </div>
      <div style={{ borderTop:"1px solid #f0f0f0", marginTop:8, paddingTop:12 }}>
        <div style={{ fontSize:9, color:"#999", letterSpacing:1.5, textTransform:"uppercase", marginBottom:4 }}>{p.category}</div>
        <div style={{ fontWeight:600, fontSize:13, color:"#1a1a2e", marginBottom:8, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{p.name}</div>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <div>
            <span style={{ fontSize:14.5, fontWeight:800, color:"#1a1a2e" }}>₹{p.price?.toLocaleString("en-IN")}</span>
            {disc > 0 && <span style={{ fontSize:10.5, color:accent, fontWeight:700, marginLeft:6 }}>-{disc}%</span>}
          </div>
          {p.stock > 0 && (
            <button onClick={addCart} style={{ background:"none", border:"none", color:accent, fontSize:11, fontWeight:800, cursor:"pointer", textDecoration:"underline", padding:0 }}>+ Add</button>
          )}
        </div>
      </div>
    </div>
  );
}
